const config = {
  apiUrl: window.runtimeConfig?.API_URL || process.env.REACT_APP_API_URL,
  authUrl: window.runtimeConfig?.AUTH_URL || process.env.REACT_APP_AUTH_URL,
  clinicCentralUrl: window.runtimeConfig?.CLINIC_CENTRAL_URL || process.env.REACT_APP_CLINIC_CENTRAL_URL,
};

export default config;
